import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import {connect} from "react-redux";
import {actionCreators} from "../redux/sagas/totalRevenueSales/totalRevenueSales";

export default connect(
  state => ({
    filterType: "Custom Range",
    options: state.totalRevenueSales.periodTypeOptions,
    includeFilter: false,
    numberDisplayed: 0,
    maxSelect: 1,
    enableMax: true,
    selectedFilters: state.totalRevenueSales.selectedFilters.period_type,
    enableDefaultSelected: true,
    haveOnSelectChange: false
  }),
  {
    updateLocations: data => actionCreators.updatePeriodType(data)
  }
)(MultiSelectDropdown);
